export default __webpack_public_path__ + "static/media/wrapped-bitcoin-wbtc-logo.fa29bebf.svg";